<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kHWuqr/tc-custom/9781626816596.jpg?1706182581365" alt="This image is the cover for the book Kiss of Gold"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kiss of Gold
      </h1>
      <p class="bookDescription body article font2">
        <b>A young Englishwoman goes searching for her father in America, only to find love and adventure on the Colorado frontier in this historical romance.</b><br/>  <br/><i>England, 1893</i>. In order to maintain her family’s elegant Bethinghamshire home, Daisie Browning faces the unhappy prospect of marrying for money—until she resolves to seek out her lost father in America. Traversing the Atlantic and the country’s wild terrain, Daisie is prepared for adventure and danger. But the last thing she expects to find on her journey is love.<br/>  <br/> When she finds herself stranded, robbed, and beset by swindlers in an isolated Colorado mining town, Daisie reluctantly accepts the help of the handsome and rakish Tyler Reede. Though she resists his advances, Daisie cannot help being drawn to Tyler—especially when she discovers that everything she truly wants can be found in his passionate embrace.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Samantha Harte
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2d3061ca